<template>
    <div>
        <v-card>
            <v-snackbar
                v-model="snackbar" :bottom="y === 'bottom'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :right="x === 'right'" :timeout="timeout" :top="y === 'top'" :vertical="mode === 'vertical'" :color="color"
            >
                {{ text }}
                <v-btn color="black" flat @click="snackbar = false">Close</v-btn>
            </v-snackbar>
        </v-card>
    </div>
</template>

<script>

export default {
    data () {
        return {
            snackbar: false,
            y: "top",
            x: "right",
            mode: "",
            timeout: 5000,
            color: "red darken-4",
            text: "Hello, I'm a snackbar"
        };
    },
    mounted () {
        var self = this;
        EventBus.$on("snackBar", function (object) {
            self.snackbar = true;
            self.text = object.text;
            self.color = object.snackbarColor;
        });
    }
};
</script>


// WEBPACK FOOTER //
// src/components/buttons/AlertSnackBar.vue